import CrudService from "@/services/shared/http/CrudService"

export default class ContactService extends CrudService {
    constructor(params= {}) {
        super('contacts', params)
    }
}
